module.exports = __webpack_public_path__ + "media/fonts/TomaSlab-SemiBold-7bcd73fe879ea95e856962e621cfa23e.woff2";